import React, { useEffect } from "react";

const PrivacyAndPolicy = () => {
  useEffect(()=>{
    document.title = "CodeQueue - Privacy & Policy"
    window.scrollTo({top:'0', behavior:'smooth'})
  })
  return (
    <div className="py-6 px md:px-16 lg:px-16 mt-16 mb-12">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="text-lg text-gray-600">Last updated: April 19, 2025</p>
      <p className="text-[17px] text-gray-600 mt-4">
        These Legal Terms constitute a legally binding agreement made between
        you, whether personally or on behalf of an entity("
        <span className="font-bold">you</span>
        "), and <span className="font-bold">CodeQueue</span>&nbsp; concerning
        your access to and use of the Services. You agree that by accessing the
        Services, you have read, understood, and agreed to be bound by all of
        these Legal Terms.{" "}
        <span className="font-semibold">
          If you do not agree with all of these legal terms, the you are
          expressly prohibited from using the services and you must discontinue
          use immediately
        </span>
      </p>
      <p className="text-[17px] text-gray-600 mt-4">
        The <span className="font-bold">CodeQueue</span> services (collectively
        referred to as the "<span className="font-bold">Services</span>") are
        provided through our website and applications (the "
        <span className="font-bold">Site</span>" or "
        <span className="font-bold">Platform</span>") by{" "}
        <span className="font-bold">CodeQueue</span> (collectively, "
        <span className="font-bold">we</span>", "
        <span className="font-bold">us</span>", or the "
        <span className="font-bold">Company</span>"). In connection with your
        use of the Services, we may collect, receive, store, use, share, and/or
        process certain information ("
        <span className="font-bold">information</span>") about you when you
        interact with or access our Services.
      </p>
      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          1. INFORMATION COLLECTION
        </h2>
        <p className="text-[17px] text-gray-600 ml-3 font-bold">
          1.1. While using our Service, we may ask you to provide us with
          certain personally identifiable Information that can be used to
          contact or identify you. Information may include, but is not limited
          to:
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">I. Your name;</p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          II. Your email address;
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          III. Phone number;
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          IV. Your Account Data such as your profile, services opted by you etc.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          V. Data related to content shared by you via your Account.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          VI. Data about your account on other services.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          VII. Data through promotions and surveys conducted by us.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          VIII. Data regarding any support concerns that you may have (this is
          only for internal purposes to optimize our Services).
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          IX. Any other information as may be disclosed by you during the use of
          Services.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          X. Information about your device.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          XI. Parts of our Services you use etc.
        </p>

        <p className="text-[17px] text-gray-600 ml-3 font-bold mt-6">
          1.2. We may also collect Information that your browser sends whenever
          you visit our Site (Log Data). This Log Data may include information
          such as:
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          I. Your IP address
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">II. Browser type</p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">III. Device type</p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          IV. Browser version
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          V. The pages of our Site that you visit
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          VI. The time and date of your visit
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          VII. The time spent on those pages and other statistics.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          VIII. Approximate geographic location, including information like
          country, city, and geographic coordinates, calculated based on your IP
          address.
        </p>

        <p className="text-[17px] text-gray-600 ml-3 font-bold mt-6">
          1.3. In order to receive payments from you, we may also collect
          (either directly or with the support of our payments partners) certain
          financial Information as may be required.
        </p>

        <p className="text-[17px] text-gray-600 ml-3 font-bold mt-6">
          1.4. In addition, we may use third party services such as cookies,
          google analytics, advertisements that collect, monitor and analyse
          this type of Information in order to increase the performance of our
          Service's. Use of such Information by these third party services shall
          be governed by their individual privacy policies. We encourage you to
          understand these policies as well.
        </p>

        <h2 className="text-[17px] text-gray-600 ml-3 font-bold mt-6">
          (i) Cookies
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          We use cookies to store and access and analyse the Information on the
          device that you use to access our Services, to personalize your
          experience, and to facilitate you to log into the Services, and to
          recognize when you return to the Services. You may opt out or refuse
          your browser from accessing/ storing the cookies or indicating when a
          cookie is being sent. However, it may be noted that some portions of
          our service may not be accessible to you if you do not accept cookies.
        </p>

        <h2 className="text-[17px] text-gray-600 ml-3 font-bold mt-6">
          (ii) Analytics
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          We use third-party browser and mobile analytics services like Google
          Analytics on the Services. These services help us analyze your use of
          the Services by using cookies, tags, scripts, customized links, device
          or browser fingerprints etc.
        </p>

        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          These services also help us analysing Information such as:
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          (a) The third-party website you arrive from;
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          (b) How often you visit the Site;
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          (c) Events within the Services; and
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          (d) Usage and performance data.
        </p>

        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          The information collected is used solely for the purpose of improving
          our Services, to better understand the behaviour projected by our
          Services on different devices, and to provide information that may be
          of interest to you.
        </p>

        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          You can opt-out of Google Analytics by visiting the Google Ads
          Settings page. Google also recommends installing the Google Analytics
          Opt-out Browser Addon for your web browser. Google Analytics Opt-out
          Browser Add-on provides visitors with the ability to prevent their
          data from being collected and used by Google Analytics. For more
          information on the privacy practices of Google, please visit the
          Google Privacy & Terms web page
        </p>

        <h2 className="text-[17px] text-gray-600 ml-3 font-bold mt-6">
          (iii) Online Advertising
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          We partner with third-party advertising platforms such as Facebook,
          Google's ad services, and other ad networks to enhance your experience
          through personalized ads and relevant content. These services help us
          display targeted advertisements based on your recent activity on our
          Site as well as your interactions across other websites and platforms.
          While we do not share any personally identifiable information with
          these advertisers, we may share aggregated data—for instance,
          informing them that a certain number of users in a specific age group
          clicked on a particular ad. This type of data helps our advertising
          partners reach the audiences that are most relevant to their
          campaigns.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          2. USE OF YOUR INFORMATION
        </h2>
        <p className="text-[17px] text-gray-600 ml-3 font-bold">
          We use your Information for purposes such as:
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          i. Providing our services to deliver the best possible user
          experience.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          ii. Enhancing our services by developing new features, tools, and
          offerings based on user needs.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          iii. Analyzing trends, traffic, and purchase behavior to better
          understand how users engage with our platform.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          iv. Gaining deeper insights into user behavior by connecting user data
          with third-party sources or using analytics service providers.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          v. Communicating with you for support, updates, feedback, or important
          service-related messages.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          vi. Diagnosing and resolving issues that you may encounter while using
          our platform.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          vii. Protecting against fraud, abuse, or misuse of our platform and
          services.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          viii. Improving and updating our services based on your feedback and
          usage patterns.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          ix. By using the website and/or registering with us, you authorize us
          to contact you via email, phone call, or SMS to offer services, share
          product information, and provide promotional offers from us or third
          parties. Even if your number is registered under DND, DNC, or NCPR,
          you consent to receive communication from{" "}
          <span className="font-bold">CodeQueue</span> for these purposes for up
          to 180 days from the date of registration.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          3. INFORMATION REVIEW
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          We encourage you to periodically review the Information you provide to
          us to ensure that it is accurate and complete, particularly in
          relation to any Information or Sensitive Personal Information (as
          defined below). We do not take responsibility for the authenticity of
          any Information or Sensitive Personal Information submitted by you.
          "Sensitive Personal Information" refers to passwords and any other
          data categorized as sensitive under Section 3 of the Information
          Technology (Reasonable Security Practices and Procedures and Sensitive
          Personal Data or Information) Rules, 2011 ("Rules"). We are committed
          to resolving any discrepancies or grievances you may have regarding
          your Information or Sensitive Personal Information within 30 days from
          the date of identification. To support this, the Company has appointed
          a Grievance Officer whose contact details are provided in the relevant
          section of this policy.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          4. SECURITY
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          We implement appropriate security measures based on the type and
          sensitivity of the Information we store. However, by using
          internet-enabled platforms, you acknowledge that there is always some
          level of risk of unauthorized access to your Information.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          Your password plays a critical role in securing your account. It is
          your responsibility to safeguard it. We strongly encourage you to keep
          your password confidential and to notify us immediately if you suspect
          any unauthorized activity on your account.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          We are committed to protecting your Information and will take all
          reasonable steps to prevent unauthorized access, alteration,
          disclosure, or destruction of your data.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          5. SHARING YOUR INFORMATION
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          The Information may be shared with third parties under the following
          circumstances, or as otherwise outlined in this Privacy Policy
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          (i) We are committed to protecting your Information and will take all
          reasonable steps to prevent unauthorized access, alteration,
          disclosure, or destruction of your data.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          (ii) We share your Information with third-party companies that perform
          services on our behalf. These services may include payment processing,
          data analysis, marketing and advertising (including retargeted
          advertising), email and hosting, customer service, and technical
          support. These service providers may have access to your Information
          but are strictly required to use it only as instructed by us and
          solely for the purpose of delivering the services we have requested
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          (iii) We have partnerships with other websites and platforms to
          distribute our Services and help drive traffic to our Site. Depending
          on your location, we may share certain data with these partners in
          accordance with applicable laws and this Privacy Policy.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          (iv) We may share your data as needed to manage, promote, or sponsor
          any promotions or surveys you choose to participate in. This may
          include sharing information as required by applicable law (e.g., to
          publish a winners list or fulfill legal obligations) or as outlined in
          the official rules of the promotion or survey.
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          (v) We may disclose your Information to third parties if we, at our
          sole discretion, believe in good faith that such disclosure is:
        </p>

        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          (a) Permitted or required under applicable laws, regulations, court
          orders, or legal investigations or proceedings;
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          (b) Reasonably necessary to enforce our Terms of Use, this Privacy
          Policy, or any other legal agreements;
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          (c) Essential for detecting, preventing, or addressing fraud, misuse,
          violations of law or regulations, abuse of our platform, or addressing
          security and technical vulnerabilities;
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          (d) Reasonably required to protect the rights, property, or personal
          safety of the Company, its users, employees, the public, or to prevent
          imminent harm;
        </p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          (e) Necessary to share with our auditors or legal advisors for the
          purpose of evaluating and fulfilling our legal responsibilities under
          this Privacy Policy.
        </p>

        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          (vi) If the Company is involved in a business transition such as a
          merger, acquisition, corporate restructuring, divestiture, dissolution
          (including bankruptcy), or the sale of all or a portion of its assets,
          your Information may be shared, disclosed, or transferred to the
          successor entity as part of or in anticipation of such a transition
          (including during due diligence processes).
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          6. INFORMATION RETENTION
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          We do not store your Sensitive Personal Information for longer than
          necessary to fulfill the lawful purposes for which it was collected.
          For other types of content, we will consider requests for deletion.
          However, it is important to note that certain public content may still
          be retained indefinitely within our systems, such as in cached and
          archived versions of the Platform, or if it has been copied or saved
          by other users. Additionally, due to the nature of the Internet, even
          if you remove or delete content from your account, copies may persist
          elsewhere on the web and remain accessible indefinitely. We may also
          retain certain Information for internal purposes, such as processing,
          analytics, fraud detection, and, in some cases, on an anonymized or
          de-identified basis.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          7. THIRD-PARTY EMBEDS
        </h2>
        <p className="text-[17px] mt-2 text-gray-800 font-semibold ml-5">
          What Are Third Party Embeds?
        </p>
        <p className="text-[17px] text-gray-600 ml-5">
          Certain content displayed on the Platform is not stored on our
          servers. Instead, it is provided through "embeds"—which are hosted by
          third-party services and integrated into our Platform. When you view
          such content, data is transmitted to the third-party host as though
          you were accessing their website directly.
        </p>
        <p className="text-[17px] mt-2 text-gray-800 font-semibold ml-5">
          Privacy Concerns With Third Party Embeds
        </p>
        <p className="text-[17px] text-gray-600 ml-5">
          The Platform does not have control over the data collected by
          third-party services or how they choose to use it. As a result, any
          third-party embedded content on the Platform is not governed by this
          Privacy Policy. Instead, such content is subject to the privacy
          policies of the respective third-party providers.
        </p>
        <p className="text-[17px] mt-2 text-gray-800 font-semibold ml-5">
          Sharing Information With Third Party Embeds
        </p>
        <p className="text-[17px] text-gray-600 ml-5">
          Some embedded content on the Platform may include forms requesting
          your Information, such as your email address. While we make every
          effort to prevent misuse, submitting your Information to a third party
          through such forms is at your own discretion. We do not have
          visibility into how that information will be used, and as noted
          earlier, such interactions are not governed by this Privacy Policy.
          Therefore, we strongly advise you to exercise caution when
          encountering embedded forms on the Platform. Ensure you fully
          understand who is collecting your data and how they intend to use it
          before submitting any personal information. Whenever possible, we
          recommend refraining from providing Information to third parties via
          embedded forms.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          8. THIRD PARTY LINKS
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          From time to time, the Platform may include links to websites or
          mobile applications operated by our partners, advertisers, affiliates,
          or other third parties. If you choose to visit any of these external
          sites, please be aware that they are governed by their own privacy
          policies. We do not take responsibility for how your data is handled
          on those platforms. Before sharing any personal information, we
          encourage you to review the privacy policies of those websites or
          applications carefully.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          9. YOUR RIGHTS
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-5">
          You have certain rights regarding the use of your Information. These
          include the ability to opt out of receiving promotional emails,
          disable cookies, and limit the collection of your data by specific
          advertising services. You can update or delete your Account directly
          through our Services, and you may also contact us to request the
          exercise of your individual rights related to your Information. At any
          time, you have the right to review, correct, or update the information
          we hold about you. Furthermore, you can withdraw your consent for the
          collection of your information moving forward. However, please note
          that withdrawing consent may impact your ability to use certain
          features of the Platform. For example, we need access to your Account
          details to allow you to use our Services, and this functionality will
          not be available to you if you choose to revoke that access. You also
          have the option to request that we stop processing your personal data
          for marketing purposes. You may exercise any of these rights by
          reaching out to us at <strong>support@codequeue.in</strong>. Please
          note that we will require a reasonable period of 30 (thirty) days to
          process and comply with any of your requests.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          10. Profile Status on CodeQueue
        </h2>
        <ol className="list-[upper-roman]">
          <li className="text-[17px] text-gray-600 ml-8 font-bold">Active</li>
          <p className="text-[17px] text-gray-600 ml-5">
            Your profile is fully active on CodeQueue, allowing you to access
            and use all features without any restrictions.
          </p>
          <li className="text-[17px] text-gray-600 ml-8 font-bold">On Hold </li>
          <p className="text-[17px] text-gray-600 ml-5">
            If we detect any suspicious or abnormal activity, your profile may
            be temporarily placed on hold for up to 48 hours. During this
            period, your access will be limited. If you fail to provide
            sufficient evidence to resolve the issue within this timeframe, your
            profile may be suspended.
          </p>
          <li className="text-[17px] text-gray-600 ml-8 font-bold">
            Suspended{" "}
          </li>
          <p className="text-[17px] text-gray-600 ml-5">
            A suspended profile indicates a violation of our platform policies
            or unresolved concerns during the hold period. Suspended profiles
            lose all access to CodeQueue's features and services.
          </p>
          <li className="text-[17px] text-gray-600 ml-8 font-bold">Deleted</li>
          <p className="text-[17px] text-gray-600 ml-5">
            If you choose to delete your profile, it will be marked as deleted
            in our system. However, CodeQueue will retain your data in
            accordance with our data retention policies. This includes cached,
            archived, or backed-up copies for legal, security, or operational
            purposes.
          </p>
        </ol>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          11. CHANGES TO PRIVACY POLICY
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          The Company may update this Privacy Policy from time to time. Any
          changes will be posted at this link. By continuing to use our Services
          after an update, you are considered to have accepted the revised
          Privacy Policy. We will also make reasonable efforts to notify you of
          any significant or material changes made to this Privacy Policy.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          12. DISCLAIMER
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          We implement industry best practices and take appropriate security
          measures to safeguard your Information and prevent unauthorized
          access. However, no method of transmission over the internet is
          completely secure. Therefore, we cannot guarantee the absolute
          security of your Information shared on the Platform. By using the
          Platform, you acknowledge and accept that any data transmission is
          carried out at your own risk.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          13. COMMUNICATIONS FROM US
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          From time to time, we may send you service-related announcements when
          deemed necessary—such as notifications about platform maintenance,
          security updates, privacy matters, or other administrative
          communications. These messages may be delivered via SMS, email, push
          notifications, or other available channels. Please note that these
          communications are not promotional in nature and are intended solely
          to safeguard your account and keep you informed about critical updates
          to the Platform. As such, you may not opt out of receiving them.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
          14. GRIEVANCE OFFICER
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">
          If you have any concerns or grievances regarding this Policy, the way
          we collect or handle your information, or anything related to your
          personal data shared with us, please feel free to contact us at{" "}
          <strong>support@codequeue.in</strong>. We are committed to resolving
          your concerns and will make every reasonable effort to address your
          grievance within 30 days from the date of its receipt.
        </p>
      </div>

      <div>
      <h2 className="text-lg font-bold mt-4 mb-2 text-gray-600">
        INTELLECTUAL PROPERTY POLICY
        </h2>
        <p className="text-[17px] mt-2 text-gray-600 ml-6">All content available on the CodeQueue platform—including but not limited to documents, images, text, audio, graphics, software, maps, photographs, sounds, logos, HTML files, and interactive features (collectively, “Content”)—is either the property of CodeQueue or has been licensed to CodeQueue by third parties</p>
        <p className="text-[17px] mt-2 text-gray-600 ml-6">The Platform and all related Services are owned and operated by CodeQueue and/or its licensors. This includes all intellectual property rights related to the design, structure, selection, coordination, expression, and arrangement of such content and materials.</p>
        <p className="text-[17px] mt-2 text-gray-600 ml-6">Users are granted a limited, non-exclusive, non-transferable license to access and use the Platform and its Content for personal or internal business use only, in accordance with these terms. Any unauthorized use, reproduction, modification, distribution, or republication of any part of the Content is strictly prohibited without prior written consent from CodeQueue.</p>

        <p className="text-[17px] text-gray-600 ml-3 font-bold mt-6">1. HOW TO REPORT INFRINGEMENT</p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">If you believe that any content or course available on the Platform infringes upon your copyright or trademark, please report it to us at <span className="font-bold">support@gmail.com</span>, and provide the necessary details as outlined in the Infringement Claim Form located at the end of this document.</p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8 font-semibold">Before submitting your report, please note the following:</p>
        <ol className="list-[lower-roman]">
          <li className="text-[17px] text-gray-600 ml-8 mt-2">We are unable to process any infringement claim that is not submitted by the copyright or trademark owner or their authorized representative. Accordingly, we require you to provide a physical or electronic signature confirming that you are the intellectual property owner or have the legal authority to act on their behalf.</li>
          <li className="text-[17px] text-gray-600 ml-8 mt-2">Your copyright/ trademark right claim should provide the following information:</li>
          <ol className="list-disc ml-10 text-[17px] text-gray-600">
            <li>Please include your complete contact details—full legal name, email address, and physical mailing address.</li>
            <li>Share a clear reference to the original content, such as a URL or any location where the material can be verified.</li>
            <li>Include a sworn statement: “I affirm that the information provided is true to the best of my knowledge, that I am the copyright/trademark owner or authorized to act on their behalf, and that the reported use is not permitted by the owner, their agent, or the law.”</li>
          </ol>
          <li className="text-[17px] text-gray-600 ml-8 mt-2">Knowingly submitting a false or misleading claim of copyright or trademark infringement is a violation of the law. You may be held legally liable for damages, including costs and attorneys’ fees, incurred by CodeQueue or any affected third party as a result of such misrepresentation.</li>
          <li className="text-[17px] text-gray-600 ml-8 mt-2">Content like short phrases, ideas, processes, recipes, or facts is not eligible for copyright protection, and upon receiving a properly detailed complaint, CodeQueue will review and, if infringement is confirmed, make reasonable efforts to remove the violating material from the Platform.</li>
        </ol>

        <p className="text-[17px] text-gray-600 ml-3 font-bold mt-6">DESIGNATED AGENT CONTACT INFORMATION</p>
        <p className="text-[17px] mt-2 text-gray-600 ml-8">Designated agent for form of reported infringement can be contacted in the following manner: Via Email: <span className="font-bold">support@codequeue.in</span></p>
        <p className="text-[17px] text-gray-600 ml-3 font-bold mt-6">Infringement Claim Form : </p>
        <ol className="list-decimal ml-8 text-[17px] text-gray-600">
          <li>What is your claim?</li>
          <li>Link to the content Add links</li>
          <li>Who is affected? </li>
          <li>How does it affect them?</li>
          <li>It hampers the right holder’s ability to:</li>
          <ol className="list-disc ml-4">
            <li>Reproduce the work in any form, including storing it electronically or distributing copies to the public.</li>
            <li>Perform in public or, communicate in public</li>
            <li>Record/ translate/ adapt the work </li>
            <li>Sell/ rent the work</li>
            <li>Others</li>
          </ol>
          <li>How else does this amount to infringement ?</li>
          <li>Who are you?</li>
          <ol className="list-disc ml-4">
            <li>Proof of relationship – contract / letter of authorisation / power of attorney etc</li>
            <li>Email:</li>
            <li>Phone:</li>
            <li>Personal Name:</li>
            <li>Address:</li>
            <li>Landmark:</li>
            <li>City:</li>
            <li>Pincode:</li>
            <li>Country:</li>
          </ol>
          <li>Verification (signature)</li>
          <li>Any other details.</li>
        </ol>
        <p className="text-[17px] text-gray-600 ml-3 font-bold mt-6">Declaration</p>
        <p className="text-[17px] text-gray-600 ml-8">I affirm that this complaint is made in good faith and to the best of my knowledge, the information provided is true and accurate. I have taken all reasonable steps to verify the validity of my claim, which complies with applicable laws and does not fall under any exceptions outlined in Indian law. I confirm that I have the legal authority to submit this complaint, and that my actions are not intended to be frivolous, malicious, or to harass any individual or entity.</p>
      </div>
    </div>
  );
};

export default PrivacyAndPolicy;
